import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { stringify } from 'query-string';

import {
  DataBlocks,
  I18n,
  ErrorBlock,
} from 'components';

import {
  fetchPostpaidInitialData,
  sendInvoiceToEmail,
  togglePaymentsDetailsRow,
} from '../../actions';

import CurrentPeriodExpenses from '../../components/CurrentPeriodExpenses';
import PostpaidInvoices from '../../components/PostpaidInvoices';
import SendInvoicePopup from '../../components/SendInvoicePopup';
import Payments from '../Payments';

const getEmail = (bens, benNumber) => bens.find((ben) => ben.benNumber === benNumber).email || '';

class BanDetalization extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isPopupOpened: false,
      currentInvoice: {},
      email: '',
    };
  }

  componentDidMount() {
    this.props.actions.fetchPostpaidInitialData();
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.isEmpty) {
      props.history.push(`${props.match.path}/ctn`);
    }
  }

  render() {
    const {
      invoicePeriods,
      currentPeriod,
      currency,
      actions,
      error,
      isSending,
      sendingError,
      history,
      match,
      paymentUrl,
      isFetching,
      showCostsBlock,
    } = this.props;

    const {
      isPopupOpened,
      currentInvoice,
      email,
    } = this.state;

    if (error) {
      return (
        <ErrorBlock
          title={<I18n path="detalization.blockTitle" />}
          refreshAction={actions.fetchPostpaidInitialData}
        />
      );
    }

    return (
      <DataBlocks.Container>
        <DataBlocks.Block
          isLoading={isFetching}
          title={<I18n path="detalization.blockTitle" />}
        >
          <CurrentPeriodExpenses
            period={currentPeriod}
            showCostsBlock={showCostsBlock}
            currency={currency}
            onCtnClick={(data) => history.push({
              pathname: `${match.path}/ctn`,
              search: stringify(data),
            })}
          />
          <PostpaidInvoices
            invoices={invoicePeriods}
            currency={currency}
            paymentUrl={paymentUrl}
            startDateOfCurrentPeriod={currentPeriod && currentPeriod.startDate}
            onPeriodClick={(data) => {
              window.scrollTo(0, 0);
              history.push({
                pathname: `${match.path}/invoice`,
                search: stringify(data),
              });
            }}
            onInvoiceNumberClick={(invoice) => this.setState({
              currentInvoice: invoice,
              email: getEmail(currentPeriod.bens, invoice.benNumber),
              isPopupOpened: true,
            })}
          />
        </DataBlocks.Block>
        <Payments
          postpaid
          toggleDetailsRow={actions.togglePaymentsDetailsRow}
        />
        <SendInvoicePopup
          email={email}
          isOpened={isPopupOpened}
          closePopup={() => this.setState({
            isPopupOpened: false,
          })}
          sendInvoice={actions.sendInvoiceToEmail}
          isSending={isSending}
          sendingError={sendingError}
          {...currentInvoice}
        />
      </DataBlocks.Container>
    );
  }
}

const mapStateToProps = (state) => ({ ...state.detalization.invoices });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    fetchPostpaidInitialData,
    sendInvoiceToEmail,
    togglePaymentsDetailsRow,
  }, dispatch),
});

BanDetalization.propTypes = {
  invoicePeriods: PropTypes.array,
  currentPeriod: PropTypes.object,
  error: PropTypes.string,
  isSending: PropTypes.bool,
  sendingError: PropTypes.string,
  currency: PropTypes.string,
  actions: PropTypes.object,
  history: PropTypes.object,
  paymentUrl: PropTypes.string,
  isEmpty: PropTypes.bool,
  match: PropTypes.object,
  isFetching: PropTypes.bool,
  showCostsBlock: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(BanDetalization);
